/**
 * Shared Axios config for multipart/form-data requests (podcast/episode file uploads).
 */
export const MULTIPART_HEADERS = { headers: { "Content-Type": "multipart/form-data" } }

/**
 * Build a FormData payload for an episode update/create request.
 * Appends the serialized episode JSON and, if present, a logo file.
 *
 * @param {Object} episode  Episode data object (may include a `logoFile` File).
 * @returns {FormData}
 */
export const buildEpisodeFormData = (episode) => {
  const data = new FormData()
  data.append("episode", JSON.stringify(episode))
  if (episode.logoFile) {
    data.append("logo", episode.logoFile)
  }
  return data
}

